import React from "react";
import { Box, TextField, InputAdornment, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";

const BroadcastNavbar = ({ searchValue, onSearchChange, onAddBroadcast }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        padding: { xs: "8px 10px", sm: "10px 14px", md: "12px 16px" },
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <TextField
        placeholder="Search"
        variant="outlined"
        size="small"
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{
          width: { xs: "60%", sm: "250px", md: "300px" },
          flexShrink: 0,
          backgroundColor: (theme) =>
            theme.palette.mode === "dark"
              ? theme.palette.background.default
              : "#f9f9f9",
          "& .MuiOutlinedInput-root": {
            padding: "1px 10px",
            borderRadius: "12px",
            "& fieldset": {
              borderColor: (theme) => theme.palette.divider,
            },
            "&:hover fieldset": {
              borderColor: (theme) => theme.palette.primary.main,
            },
          },
          "& .MuiInputBase-input": {
            fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.85rem" },
            color: (theme) => theme.palette.text.primary,
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon
                sx={{
                  color: (theme) => theme.palette.text.secondary,
                  fontSize: { xs: "18px", sm: "19px", md: "20px" },
                }}
              />
            </InputAdornment>
          ),
        }}
      />
      <Button
        variant="contained"
        startIcon={<AddIcon sx={{ fontSize: { xs: "16px", sm: "18px", md: "20px" } }} />}
        onClick={onAddBroadcast}
        sx={{
          borderRadius: "2rem",
          textTransform: "none",
          whiteSpace: "nowrap",
          fontSize: { xs: "11px", sm: "12px", md: "14px" },
          padding: { xs: "5px 10px", sm: "6px 14px", md: "8px 20px" },
          minHeight: { xs: "30px", sm: "34px", md: "36px" },
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "#0E9046" : theme.palette.primary.main,
          "&:hover": {
            backgroundColor: (theme) =>
              theme.palette.mode === "dark" ? "#4FC389" : theme.palette.primary.dark,
          },
        }}
      >
        Add Broadcast
      </Button>
    </Box>
  );
};

export default BroadcastNavbar;
